import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { Spdr } from "../Spdr";
import { TextFieldInput } from "../../../Forms/TextFieldInput";
import { isElementInArray } from "../../../Utils/arrays";
import { MdmFormProps } from "../../../Forms/MdmFormProps";

export const SpdrInboundForm = ({ disabledFields }: MdmFormProps) => {
  const { control } = useFormContext<Spdr>();

  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={6}>
        <BorderedFormGrid>
          <Grid item xs={6}>
            <TextFieldInput
              name="InboundMegaLdm"
              control={control}
              label="Inbound Mega LDM"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={6}>
            <Controller
              name="InScope"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  disabled={isElementInArray(disabledFields, "InScope")}
                >
                  <InputLabel id="in-scope-label">In Scope</InputLabel>
                  <Select {...field} labelId="in scope-label" label="In Scope">
                    <MenuItem value={true as any}> In Scope </MenuItem>
                    <MenuItem value={false as any}>Out of Scope</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <TextFieldInput
              name="InboundEuroLdm"
              control={control}
              label="Inbound Euro LDM"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={6}>
            <TextFieldInput
              name="InboundMissingPackagePercent"
              control={control}
              label="Inbound Missing Package Percent"
              disabledFields={disabledFields}
            />
          </Grid>

          <Grid item xs={6}>
            <TextFieldInput
              name="InboundKg"
              control={control}
              label="Inbound Weight in kg"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={6}>
            <TextFieldInput
              name="NumberOfParts"
              control={control}
              label="Number of Parts"
              disabledFields={disabledFields}
            />
          </Grid>

          <Grid item xs={6}>
            <TextFieldInput
              name="InboundCubicMeters"
              control={control}
              label="Inbound Cubic Metres"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={6}>
            <TextFieldInput
              name="ShipIndicator"
              control={control}
              required
              label="Ship Indicator"
              disabledFields={disabledFields}
            />
          </Grid>
        </BorderedFormGrid>
      </Grid>
    </Grid>
  );
};
